interface IsNewOpportunityParams {
  date_added: string;
  last_refreshed?: string | null;
}

export const isNewOpportunity = ({
  date_added,
  last_refreshed,
}: IsNewOpportunityParams) => {
  if (last_refreshed === undefined) return false;
  if (last_refreshed === null) return true;
  const dateAdded = new Date(date_added);
  const lastRefreshed = new Date(last_refreshed);
  return dateAdded >= lastRefreshed;
};
